import {IContestTimes, IPlayHubStore} from "apps/BWW_PLAY_HUB/modules/utils/types";
import {mapValues} from "lodash";
import {getRegionSelector} from "modules/selectors/settings";
import {createSelector} from "reselect";

export const getContestTimesStore = (store: IPlayHubStore) => store.contest_times;
export const getContestTimes = createSelector(
	[getContestTimesStore, getRegionSelector],
	(times: IContestTimes, region) => {
		return mapValues(times, (value) => value[ region ]);
	}
);
